import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar';
import ModalManager from '../components/modals/ModalManager';
import ToastContainer from '../components/ui/ToastContainer';
import PageTransition from '../components/ui/PageTransition';

const AppLayout = () => (
  <div className="app-layout">
    <Sidebar />
    <main className="app-layout__main">
      <div className="app-layout__content">
        <PageTransition>
          <Outlet />
        </PageTransition>
      </div>
      <footer className="footer">
        <p className="footer__disclaimer">
          Trading involves risk. Past performance is not indicative of future results. Not financial advice.
        </p>
      </footer>
    </main>
    <ModalManager />
    <ToastContainer />
  </div>
);

export default AppLayout;
